import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setHideFooter } from '#src/store/page/actions';

// Lets a page hide the global footer (rendered by App, above the page's own
// component tree) without needing route-level hideFooter config - resets on
// unmount (and on the next page load, see the page reducer) so it can't
// leak into whichever page the user navigates to next.
export function useHideFooter(hidden = true) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideFooter(hidden));
    return () => dispatch(setHideFooter(false));
  }, [dispatch, hidden]);
}
